import React, { useState } from 'react';
import { PauseIcon, PlayIcon } from 'lucide-react';
import { busTrees } from '../../../data/beheer/system';
import { useBusFeed } from '../../../hooks/useBusFeed';
export function BusMonitor() {
  const [paused, setPaused] = useState(false);
  const [treeId, setTreeId] = useState(busTrees[0].id);
  const {
    messages,
    counts
  } = useBusFeed(paused);
  const tree = busTrees.find(t => t.id === treeId) ?? busTrees[0];
  const prefix = tree.root.replace('/#', '/');
  const shown = messages.filter(m => m.topic.startsWith(prefix)).slice(0, 40);
  return <div className="grid overflow-hidden rounded-3xl border border-white/[0.07] bg-night-900 md:grid-cols-[15rem_minmax(0,1fr)]" data-id="element-276" data-mp="2se3ra8va4uks">
      <nav aria-label="Topicbomen" className="border-b border-white/[0.06] p-3 md:border-b-0 md:border-r" data-id="element-277" data-mp="2xcf1wltef942">
        <ul className="flex gap-1 overflow-x-auto md:flex-col" data-id="element-278" data-mp="qnscmviwffr1">
          {busTrees.map(t => {
          const active = t.id === treeId;
          return <li key={t.id} data-id="element-279" data-mp="2oh680f91dl63">
                <button type="button" aria-current={active ? 'true' : undefined} onClick={() => setTreeId(t.id)} className={`flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-xl px-3 py-2.5 text-left transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${active ? 'bg-white/[0.07]' : 'hover:bg-white/[0.035]'}`} data-id="element-280" data-mp="2ogect5jcppgc">
                  <span data-id="element-281" data-mp="20l1w14fxz4rj">
                    <span className={`block text-[14px] ${active ? 'text-ink' : 'text-ink-soft'}`} data-id="element-282" data-mp="20ltt6jp6tajx">{t.label}</span>
                    <code className="block font-mono text-[11px] text-ink-muted" data-id="element-283" data-mp="29kf69zbw3xdb">{t.root}</code>
                  </span>
                  <span className="text-[12px] tabular-nums text-ink-muted" data-id="element-284" data-mp="3pxm5or2ddtqv">{counts[t.id] ?? 0}</span>
                </button>
              </li>;
        })}
        </ul>
      </nav>

      <div className="flex min-w-0 flex-col" data-id="element-285" data-mp="2imfrei3z2mx1">
        <div className="flex items-center justify-between gap-3 border-b border-white/[0.06] px-5 py-3" data-id="element-286" data-mp="2ilmro13fkxoe">
          <p className="flex items-center gap-2 text-[13px] text-ink-soft" data-id="element-287" data-mp="2nn3qzs69oc2v">
            <span className={`h-2 w-2 rounded-full ${paused ? 'bg-white/25' : 'bg-accent'}`} aria-hidden data-id="element-288" data-mp="2rnvxwero24vz" />
            <code className="font-mono text-[12px]" data-id="element-289" data-mp="2wl5ovyupeolx">{tree.root}</code>
            <span className="text-ink-muted" data-id="element-290" data-mp="1zw7sydb7wkn6">{paused ? 'gepauzeerd' : 'live'}</span>
          </p>
          <button type="button" onClick={() => setPaused(p => !p)} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white/[0.05] px-3 py-1.5 text-[13px] font-medium text-ink-soft transition-colors duration-150 hover:bg-white/[0.09] hover:text-ink" data-id="element-291" data-mp="23w8iou3roi9j">
            {paused ? <PlayIcon className="h-3.5 w-3.5" aria-hidden data-id="element-292" data-mp="1g75qwtff591b" /> : <PauseIcon className="h-3.5 w-3.5" aria-hidden data-id="element-293" data-mp="1l60gce7w5vue" />}
            {paused ? 'Hervatten' : 'Pauzeren'}
          </button>
        </div>
        <ol aria-label={`Berichten op ${tree.root}`} className="no-scrollbar h-[360px] overflow-y-auto px-5 py-3 font-mono text-[12px] leading-6" data-id="element-294" data-mp="1dmhix2xwi02a">
          {shown.length === 0 && <li className="text-ink-muted" data-id="element-295" data-mp="13o1yfitdpp1r">Wachten op berichten…</li>}
          {shown.map(m => <li key={m.id} className="grid grid-cols-[6.5rem_minmax(0,16rem)_minmax(0,1fr)] gap-4 border-b border-white/[0.03]" data-id="element-296" data-mp="zm6oxr1ao5cw">
              <span className="tabular-nums text-ink-muted" data-id="element-297" data-mp="upgaf8551htl">{m.time}</span>
              <span className="truncate text-accent/90" title={m.topic} data-id="element-298" data-mp="pwdo9l2oxanf">
                {m.topic.slice(prefix.length)}
              </span>
              <span className="truncate text-ink-soft" title={m.payload} data-id="element-299" data-mp="kw949l2kpxsg">
                {m.payload}
                {(m.retained || m.qos === 1) && <span className="ml-2 text-ink-muted" data-id="element-300" data-mp="bwm5z855583m">
                    {m.qos === 1 && 'qos1'}
                    {m.retained && ' retained'}
                  </span>}
              </span>
            </li>)}
        </ol>
      </div>
    </div>;
}